// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ContactInfoPurposeType } from './contactInfoPurposeType.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class TrialcardSiteV3ModelsSharedEmailAddressUpsearchModel {
    'emailAddressType'?: ContactInfoPurposeType;
    'address'?: string | null;
    'language'?: string | null;
    'emailAddressId'?: number | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof TrialcardSiteV3ModelsSharedEmailAddressUpsearchModel>> = [
        {
            "name":     "emailAddressType",
            "baseName": "emailAddressType",
            "type":     "ContactInfoPurposeType"
        },
        {
            "name":     "address",
            "baseName": "address",
            "type":     "string"
        },
        {
            "name":     "language",
            "baseName": "language",
            "type":     "string"
        },
        {
            "name":     "emailAddressId",
            "baseName": "emailAddressId",
            "type":     "number"
        },
    ];

    static getAttributeTypeMap() {
        return TrialcardSiteV3ModelsSharedEmailAddressUpsearchModel.attributeTypeMap;
    }
}
